import { getAppConfig } from '@configs/apps/appConfigs';

/**
 * Determines if a session type requires baseline calculation.
 * Reads the configuration from appConfigs and considers sensor connection status.
 *
 * @param type - The session type (e.g., 'performance', 'exposure', 'wellbeing')
 * @param isSensorConnected - Whether the sensor is currently connected
 * @returns true if the session type requires baseline calculation OR if the sensor is connected, false otherwise
 */
export const requiresBaseline = (
  type: string | undefined,
  isSensorConnected: boolean = false
): boolean => {
  // Se il sensore è connesso, sempre attiva il flusso baseline
  if (isSensorConnected) {
    return true;
  }

  // Se type è undefined o vuoto, non attiva il flusso baseline (a meno che il sensore non sia connesso, già controllato sopra)
  if (!type) {
    return false;
  }

  const config = getAppConfig(type);
  // Se requiresBaseline è true nelle config, attiva il flusso baseline
  return config.requiresBaseline ?? false;
};
